module.exports = __webpack_public_path__ + "static/media/Modern_BG.a0776174.png";